module.exports = "<div fxLayout=\"row\" fxLayoutGap=\"5px\">\n  <div>\n    <a  *ngIf=\"isW9Form == 'true' && role == 'PC Client'\" style=\"color:grey\" class=\"anchor-tag-w9Form\" (click)=\"downloadDocument()\" style=\"cursor: auto;\">{{fileName}}</a>\n    <a  *ngIf=\"isW9Form !== 'true' || role !=='PC Client'\" class=\"anchor-tag\" (click)=\"downloadDocument()\" style=\"cursor: pointer;\">{{fileName}}</a>\n\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/download-control/download-control.component.html
// module id = ./src/app/components/download-control/download-control.component.html
// module chunks = main